import { PageHeader } from '@/components/layout/page-header';
import { AlertsPanel } from '@/features/market-surveillance/alerts-panel';

const MarketSurveillancePage = () => (
  <div className="flex flex-col gap-4">
    <PageHeader title="Market Surveillance" />
    <AlertsPanel />
  </div>
);
MarketSurveillancePage.displayName = 'MarketSurveillancePage';

export default MarketSurveillancePage;
